import Fallback from "app/components/Fallback";
import React from "react";

const Home = React.lazy(() => import("app/modules/website-builder/pages/home"));
const Theme = React.lazy(() =>
  import("app/modules/website-builder/pages/theme")
);
const GalleryAndLinks = React.lazy(() =>
  import("app/modules/website-builder/pages/gallery")
);
const AboutUs = React.lazy(() =>
  import("app/modules/website-builder/pages/aboutUs")
);
const Academics = React.lazy(() =>
  import("app/modules/website-builder/pages/academics")
);
const AchievementsHub = React.lazy(() =>
  import("app/modules/website-builder/pages/achievementsHub")
);
const SchoolInformation = React.lazy(() =>
  import("app/modules/website-builder/pages/schoolInformation")
);

export const ThemePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Theme {...props} />
  </React.Suspense>
);
export const HomePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Home {...props} />
  </React.Suspense>
);
export const GalleryAndLinksPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <GalleryAndLinks {...props} />
  </React.Suspense>
);
export const AboutUsPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AboutUs {...props} />
  </React.Suspense>
);
export const AcademicsPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <Academics {...props} />
  </React.Suspense>
);
export const AchievementsHubPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <AchievementsHub {...props} />
  </React.Suspense>
);
export const SchoolInformationPage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <SchoolInformation {...props} />
  </React.Suspense>
);
